import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { getGender } from "../../../../graphql/queries";
import { updateGender } from "../../../../graphql/mutations";
import SimpleCreateEdit from "../../../Common/Crud/SimpleCreateEdit";
import TextInput from "../../../../components/Common/TextInput";
import * as GendersConstants from "../../../../graphql/Constants/Genders/Types";
import nameChangeHandler from "../../../Common/Crud/formHandlers/nameChangeHandler";
import orderChangeHandler from "../../../Common/Crud/formHandlers/orderChangeHandler";
import nameOnlyFormsValidationHandler from "../../../Common/Crud/formHandlers/nameOnlyFormsValidationHandler";
import * as CrudActionTypes from "../../../../constants/Crud/ActionTypes";

const GenderEdit = (props) => {
  // states
  const [name, setName] = useState("");
  const [order, setOrder] = useState(0);
  const [inputFieldsDisable, setInputFieldsDisable] = useState(false);
  const [errors, setErrors] = useState({});
  const [updateButtonDisableStatus, setUpdateButtonDisableStatus] = useState(
    false
  );

  //#region update gender business logic
  const handleUpdateGender = async () => {
    try {
      // initial required Skill update data
      let input = {
        id: props.match.params.genderId,
        name: name.trim(),
        order: order
      };

      await API.graphql(graphqlOperation(updateGender, { input }));
      return { result: true, message: `Gender updated successfully` };
    } catch (error) {
      return {
        result: false,
        message: `Error updating gender, ${JSON.stringify(error, null, 2)}`,
      };
    }
  };
  //#endregion

  return (
    <SimpleCreateEdit
      {...props}
      crudActionType={CrudActionTypes.Edit}
      returnHandler={() => props.history.push(`/genders`)}
      modelName="Gender"
      getModelMethod={async () => {
        let result = await API.graphql(
          graphqlOperation(getGender, { id: props.match.params.genderId })
        );
        if (result) {
          setName(result.data.getGender.name);
          setOrder(result.data.getGender.order);
        }
        return result.data.getGender;
      }}
      createOrUpdateDisableMethod={(modelData) => {
        if (modelData.id === GendersConstants.Other.id) return true;
        return false;
      }}
      createOrUpdateDisabledActions={() => {
        setInputFieldsDisable(true);
      }}
      formSubmissionHandler={handleUpdateGender}
      formValidationHandler={() =>
        nameOnlyFormsValidationHandler(
          name,
          "Gender",
          true, // we need to exclude the OTHER
          setUpdateButtonDisableStatus,
          setErrors
        )
      }
      setErrorsState={() => setErrors}
      actionButtonDisabledState={updateButtonDisableStatus}
    >
      <TextInput
        type="name"
        id="name"
        label="Gender Name"
        placeholder="Enter a Gender name"
        value={name}
        onChange={(e) =>
          nameChangeHandler(
            e,
            "Gender",
            true, // we need to exclude the OTHER,
            setName,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.name}
        disabled={inputFieldsDisable}
      />
      <TextInput
        type="number"
        id="order"
        label="Gender Order"
        placeholder="Enter a Gender Order"
        value={order}
        onChange={(e) =>
          orderChangeHandler(
            e,
            "Gender",
            setOrder,
            setUpdateButtonDisableStatus,
            setErrors
          )
        }
        isRequired={true}
        error={errors.order}
        disabled={inputFieldsDisable}
      />
    </SimpleCreateEdit>
  );
};

export default GenderEdit;
